import { QuerableDataSourceType } from '/@services/generated/graphql-types';

const EMBRACE_OAUTH_FAILURE_CODES = [
    '12132',
    '12133',
    '12135',
    '12136',
    '12137',
    '12138',
];

const EMBRACE_FAILURE_CODES = ['12119', '12120', '12121', '12325'];

const isExternalDataSourceType = (
    querableDataSourceType: QuerableDataSourceType,
) =>
    querableDataSourceType !== QuerableDataSourceType.Default &&
    querableDataSourceType !== QuerableDataSourceType.RdbmsFalcon;

export {
    EMBRACE_OAUTH_FAILURE_CODES,
    EMBRACE_FAILURE_CODES,
    isExternalDataSourceType,
};
